(function () {
    'use strict';

    angular.module("imApp").factory("productUnitDataService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 587,
                    parameters: parms || {}
                });
            },
            listFactorInputMethods: function (parms) {
                return $ihttp.post({
                    method: 2946,
                    parameters: parms || {}
                });
            },
            changeInputMethod: function (edit) {
                return $ihttp.post({
                    method: 2947,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 589,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
